import(/* webpackMode: "eager" */ "/home/cauns/apps/facility-managers/tenant/node_modules/.pnpm/next@15.5.12_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/cauns/apps/facility-managers/tenant/src/components/ui/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/home/cauns/apps/facility-managers/tenant/src/components/user-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/cauns/apps/facility-managers/tenant/src/resources/css/globals.css");
;
import(/* webpackMode: "eager" */ "/home/cauns/apps/facility-managers/tenant/src/resources/css/legacy.css");
